import i18n from '../../../../i18n';

export default {
  version: 'نسخه: ',
  filled: 'تکمیل شده',
  add: 'افزودن',
  addContent: 'افزودن محتوا',
  addDescription: 'افزودن توضیحات',
  addLinkToAnotherDoc: 'افزودن پیوند به سند دیگر',
  addTag: 'افزودن برچسب',
  cancel: 'لغو',
  cancelMove: 'لغو انتقال',
  changeFile: 'تغییر عکس',
  changeLimitation: 'مدیریت دسترسی‌',
  singleItemAccessTokenLinks: 'لینک دسترسی مستقیم',
  migrateUserPermissionsToRole: 'انتقال دسترسی‌های شخص به نقش',
  showInParent: 'نمایش در پوشه اصلی',
  copyLink: 'کپی لینک به این سند',
  linkCopiedToClipboard: 'کپی شد',
  pastCopiedFiles: 'جایگذاری اسناد کپی شده',
  noItemFound: 'سندی پیدا نشد',
  errorReadingClipboard: 'امکان دسترسی به کلیپرد وجود ندارد',
  copingItems: 'در حال انتقال اطلاعات ...',
  copyItem: 'کپی پوشه',
  lastFilled: 'آخرین ارسال شما',
  pleaseEnterInputHere: 'اینجا وارد کنید',
  showingDeletedFiles: '✔ نمایش اسناد حذف شده',
  showDeleted: 'نمایش اسناد حذف شده',
  itemRestore:
    'سند به همراه تمام محتویات آن که در هنگام حذف وجود داشتند بازگردانی شد',
  permissionHint: 'راهنمای دسترسی',
  indicator: 'شاخص',
  changeThumbnail: 'تغییر آیکن',
  chooseFile: 'انتخاب فایل',
  close: 'بستن',
  configuration: 'پیکربندی',
  confirm: 'تایید',
  url: 'آدرس',
  deleteLink: 'حذف پیوند',
  restore: 'بازگردانی',
  delete: 'حذف',
  description: 'توضیحات',
  documentManagerTitle: '',
  documentManagerDescription: '',
  duplicate: 'ایجاد کپی',
  edit: 'ویرایش',
  editAccess: 'دسترسی ویرایش',
  enterTitleError: 'عنوان جدید نمی‌تواند خالی باشد',
  errorHappensOnCreatingNewFilePleaseTryAgain:
    'خطایی هنگام ایجاد پرونده‌ی جدید رخ داد؛ لطفاً دوباره تلاش کنید',
  folderIsEmpty: 'این پوشه خالیست',
  limitedItemText:
    'این ایتم محدود شده است و تنها افراد زیر می‌توانند به این ایتم دسترسی داشته باشند.',
  linkToProfileAction: 'پیوند به نمایه دیگران',
  linkDescription: 'توضیحات پیوند',
  loading: 'در حال بارگیری',
  move: 'تغییر مکان',
  namePlaceHolder: 'عنوان فایل',
  nameTitle: 'عنوان',
  newDocumentPlaceholder: 'عنوان فایل را وارد کنید',
  newDocumentTitle: 'عنوان',
  newFolderAction: 'ایجاد پوشه',
  newFolderPlaceholder: 'عنوان پوشه را وارد کنید',
  newFolderTitle: 'عنوان',
  newLinkAction: 'ایجاد پیوند به نمایه دیگران',
  newExternalLinkAction: 'ایجاد پیوند به خارج',
  newLinkPlaceholder: 'نام کابر مورد نظر را وارد کنید.',
  newExternalLinkPlaceholder: 'عنوان لینک را وارد کنید.',
  newLinkTitle: 'جستجو',
  newExternalLinkTitle: 'عنوان',
  newQuillAction: 'ایجاد یک صفحه',
  newQuillPlaceholder: 'عنوان صفحه را وارد کنید',
  newQuillTitle: 'عنوان',
  newReportAction: 'ایجاد داشبورد',
  newSurveyAction: 'ایجاد یک پرسش‌نامه',
  newChecklistAction: 'ایجاد یک پرسشنامه',
  newIndicatorAction: 'ایجاد یک شاخص',
  newSearchTagAction: 'ایجاد پوشه‌ی هوشمند',
  newSurveyPlaceholder: 'عنوان پرسش‌نامه',
  newIndicatorPlaceHolder: 'عنوان شاخص',
  newSurveyTitle: 'پرسش‌نامه',
  no: 'خیر',
  notChanged: 'دسترسی‌ها تغییری نکرده است',
  paste: 'گذاشتن محتویات در این پوشه',
  copyFolderContent: 'کپی محتویات این پوشه',
  previousSurveyPlaceHolder: 'عنوان پرسش‌نامه را وارد کنید',
  previousSurveyTitle: 'عنوان پرسش‌نامه‌ی قبلی',
  readAccess: 'دسترسی مشاهده',
  relatedTasks: 'وظیفه‌های مرتبط',
  removeLimitation: 'حذف محدودیت',
  rename: 'تغییر عنوان',
  roleLimitation: 'دسترسی سریع',
  save: 'ذخیره',
  saveSuccess: 'ذخیره شد',
  uploadAFileAction: 'بارگذاری فایل',
  useExistingSurvey: 'استفاده از پرسش‌نامه‌های که قبلا ایجاد کرده‌ام.',
  userLimitation: 'مدیریت کاربران',
  view: 'مشاهده',
  yes: 'بله',

  changeLimitationOf(name: string) {
    return i18n.t('changeLimitationOf', { ns: 'documentManager', name });
  },
  changeThumbnailOf(name: string) {
    return i18n.t('changeThumbnailOf', { ns: 'documentManager', name });
  },
  cuted(fileName: string, fileType: string) {
    let message = '';
    switch (fileType) {
      case 'survey':
        message += 'پرسشنامه‌ی';
        break;
      case 'link':
        message += 'پیوند';
        break;
      case 'folder':
        message += 'پوشه‌ی';
        break;
      case 'quill':
        message += 'صفحه‌ی';
        break;
      case 'chart':
        message += 'جدول';
        break;
      case 'tag':
        message += 'برچسب';
        break;
      default:
        message += 'فایل';
    }
    message +=
      ' «' + fileName + '» آمادهٔ جابجایی ست؛ مقصد انتقال را انتخاب کنید.';
    return message;
  },
  deleteDocumentMessage(docName: string) {
    return 'آیا مطمئنید می‌خواهید فایل ' + docName + ' را حذف کنید؟';
  },
  deleteDocumentTitle(docName: string) {
    return 'حذف فایل ' + docName;
  },
  deleteFolderMessage(folderName: string) {
    return (
      'آیا مطمئنید که می‌خواهید پوشه‌ی «' +
      folderName +
      '» و همه‌ی محتوای آن را پاک کنید؟'
    );
  },
  deleteFolderTitle(folderName: string) {
    return 'حدف پوشه‌ی ' + folderName;
  },
  deleteItemLinkMessage(name: string) {
    return 'آیا مطمئنید که می‌خواهید پیوند به سند «' + name + '» را پاک کنید؟';
  },
  deleteItemLinkTitle(name: string) {
    return 'حذف پیوند به سند ' + name;
  },
  deleteLinkMessage(name: string) {
    return 'آیا مطمئنید که می‌خواهید پیوند «' + name + '» را پاک کنید؟';
  },
  deleteExternalLinkMessage(name: string) {
    return 'آیا مطمئنید که می‌خواهید پیوند «' + name + '» را پاک کنید؟';
  },
  deleteLinkTitle(name: string) {
    return 'حذف پیوند به نمایه ' + name;
  },
  deleteExternalLinkTitle(name: string) {
    return 'حذف پیوند به خارج ' + name;
  },
  deleteQuillMessage(quillName: string) {
    return (
      'آیا مطمئنید که می‌خواهید صفحه‌ی «' +
      quillName +
      '» و همه‌ی محتوای آن را پاک کنید؟'
    );
  },
  deleteQuillTitle(quillName: string) {
    return 'حذف صفحه‌ی ' + quillName;
  },
  deleteSearchTagTitle(name: string) {
    return 'حذف جستجوی برچسب ' + name;
  },
  deleteSearchTagMessage(name: string) {
    return 'آیا مطمئنید که می‌خواهید جستجوی برچسب «' + name + '» را پاک کنید؟';
  },
  deleteSurveyMessage(name: string) {
    return (
      'آیا مطمئنید که می‌خواهید پرسش‌نامه «' +
      name +
      '» و همه‌ی محتوای آن را پاک کنید؟'
    );
  },
  deleteSurveyTitle(name: string) {
    return 'حذف پرسش‌نامه‌ی ' + name;
  },

  movedFailed(fileNames: string[], targetFolderName: string) {
    let message = 'در انتقال';
    if (fileNames.length > 1) {
      message += ' فایل‌های';
      for (const fileName of Object.values(fileNames)) {
        message += ' «' + fileName + '»,';
      }
    } else {
      message += ' فایل «' + fileNames[0] + '»';
    }
    message += ' به پوشه‌ی ' + targetFolderName;
    message += ' مشکلی رخ داد. لطفا دوباره تلاش کنید.';
    return message;
  },
  movedSuccessfully(fileNames: string[], targetFolderName: string) {
    let message = ' انتقال';
    if (fileNames.length > 1) {
      message += ' فایل‌های';
      for (const fileName of Object.values(fileNames)) {
        message += ' «' + fileName + '»,';
      }
    } else {
      message += ' فایل «' + fileNames[0] + '»';
    }
    message += ' به پوشه‌ی ' + targetFolderName;
    message += ' با موفقیت انجام شد.';
    return message;
  },
  copyContent(name: string, domain: string) {
    return `محتویات پوشه ${name} از آدرس ${domain} به داخل این پوشه کپی شود؟`;
  },
  itemCopied(count: any) {
    return i18n.t('itemCopied', { ns: 'documentManager', count });
  },
  createTemplate(title: string) {
    return 'ایجاد ' + title;
  },
  showTemplate(title: string) {
    return 'مشاهده ' + title + '‌های موجود';
  },
  modalTitle(itemName: string, taskName: string) {
    return taskName + '‌های موجود برای ' + itemName;
  },
};
